/**
 * "Store not ready": the distributor behind this store has no live-terms
 * ThreadFlow subscription, so the order build refuses every order (F3, Jake
 * 2026-10-30).
 *
 * The server answers with 400 and the JSON:API error code
 * `store_not_ready` (api/src/pricing/billing_lapse.py, StoreNotReady), and
 * the shopper store read carries the same answer as `store_not_ready`. The
 * message below is the server's, word for word, so the notice reads the
 * same whether the cart learned it on load or from a refused submit. It
 * says nothing about billing: the store is the shopper's only contact.
 */

export const STORE_NOT_READY_CODE = "store_not_ready";

export const STORE_NOT_READY_MESSAGE =
  "This store is not ready to take orders yet. Please contact the store.";

/**
 * Is this failed request the order build's `store_not_ready` refusal?
 * Read from either error shape (SAFRS's `{errors: [{code}]}` or the Flask
 * handler's flat `{code}`), on the 400 the API uses for it. Keyed on the
 * CODE, never the status alone: every checkout guard answers 400.
 */
export function isStoreNotReadyRefusal(error) {
  if (error?.response?.status !== 400) return false;
  const data = error.response.data || {};
  const first = Array.isArray(data.errors) ? data.errors[0] : null;
  const code = data.code || first?.code;
  return code === STORE_NOT_READY_CODE;
}
